module.exports = __webpack_public_path__ + "img/24.a31c1c34.jpg";